// libs
import styled, { css } from 'styled-components'
// icons
import EditIconOrigin from '@mui/icons-material/Edit'
import BlockIconOrigin from '@mui/icons-material/Block'
// themes
import { colors } from 'themes/index'
// utils
import { size } from 'polished'

export const ButtonsWrapper = styled('div')`
  background-color: ${colors.white100};
  border-radius: 25px;
  border: 1px solid ${colors.blue500};
  display: inline-flex;
  height: 24px;
  justify-content: space-around;
  width: fit-content;
  min-width: 38px !important;
  padding: 0 2px;

  > div:not(:last-child) {
    border-right: 1px solid ${colors.blue500};
  }

  > div {
    padding: 0 2px;
    min-width: 24px;
  }
`

export const Button = styled.div<{ disabled?: boolean }>`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;

  ${({ disabled }) =>
    disabled
      ? css`
          pointer-events: none;
          cursor: default;

          svg {
            path {
              fill: ${colors.gray320};
            }
          }
        `
      : css`
          cursor: pointer;

          &:hover {
            opacity: 0.7;
          }
        `}
`

export const EditIcon = styled(EditIconOrigin)`
  margin: 0 !important;
  ${size('16px')};

  path {
    fill: ${colors.blue500};
  }
`

export const RevokeIcon = styled(BlockIconOrigin)`
  margin: 0 !important;
  ${size('16px')};

  path {
    fill: ${colors.blue500};
  }
`
